export const FEATURE_FLAGS = Object.freeze({
  trxUploads: 'trx_uploads',
  trxLambda: 'trx_lambda',
  operators: 'operators',
  orders: 'orders',
  outsideBoundaryPoints: 'outside_boundary_points',
  editLegend: 'edit-legend',
  demHillshadeColor: 'dem_hillshade_color',
  threeDMap: 'three_d_map',
  largeFieldBoundaries: 'large_field_boundaries',
  gisProxy: 'gis_proxy',
})
